import { mapState } from 'vuex'

import gaMixin from '@/mixins/ga'

import Icon from '@/components/icon'
import loaderImg from '@/assets/lazy-loader.svg'

export default {
  mixins: [gaMixin],
  components: {
    appIcon: Icon
  },
  data () {
    return {
      slideshow: null,
      start: false,
      indexSlide: 0,
      classActive: 'slideshow__item--active',
      duration: 4000,
      timeout: null,
      isPlaying: false,
      isFullscreen: false,
      loaderImg: loaderImg
    }
  },
  computed: {
    ...mapState('tours', ['photos', 'ready']),
    ...mapState('utils', ['widgets']),
    photosCount () {
      return this.photos.length
    }
  },
  methods: {
    addActiveSlide (index) {
      this.$refs.slide[index].classList.add(this.classActive)
    },
    removeActiveSlide () {
      this.$refs.slide.forEach((item) => {
        item.classList.remove(this.classActive)
      })
    },
    prevSlide () {
      if (this.indexSlide === 0) {
        this.indexSlide = this.$refs.slide.length - 1
      } else {
        this.indexSlide = --this.indexSlide
      }

      this.removeActiveSlide();
      this.addActiveSlide(this.indexSlide)
    },
    nextSlide () {
      if (this.indexSlide === this.$refs.slide.length - 1) {
        this.indexSlide = 0
      } else {
        this.indexSlide = ++this.indexSlide
      }

      this.removeActiveSlide()
      this.addActiveSlide(this.indexSlide)
    },
    runTimeout () {
      this.timeout = setTimeout(() => {
        this.nextSlide()
        this.runTimeout()
      }, this.duration)
    },
    pauseTimeout () {
      clearTimeout(this.timeout)
    },
    resetTimeout () {
      if (this.isPlaying) {
        this.pauseTimeout()
        this.runTimeout()
      }
    },
    togglePlay () {
      this.isPlaying = !this.isPlaying

      if (this.isPlaying) {
        this.runTimeout()
      } else {
        this.pauseTimeout()
      }
    },
    requestFullscreen () {
      const el = this.slideshow
      
      if (el.requestFullscreen) {
				el.requestFullscreen()
			} else if (el.mozRequestFullScreen) {
				el.mozRequestFullScreen() // Firefox
			} else if (el.webkitRequestFullscreen) {
				el.webkitRequestFullscreen() // Chrome and Safari
      }
    },
    exitFullscreen () {
      if (document.exitFullscreen) {
				document.exitFullscreen()
			} else if (document.mozExitFullscreen) {
				document.mozExitFullscreen() // Firefox
			} else if (document.webkitExitFullscreen) {
				document.webkitExitFullscreen() // Chrome and Safari
      }
    },
    onClickNextSlide () {
      this.resetTimeout()
      this.nextSlide()
    },
    onClickPrevSlide () {
      this.resetTimeout()
      this.prevSlide()
    },
    onArrowsKeyUp (evt) {
      switch (evt.code) {
        case 'ArrowLeft':
          this.onClickPrevSlide()
          break
        case 'ArrowRight':
          this.onClickNextSlide()
          break
        case 'Space':
          this.togglePlay()
          break
      }
    },
    onFullscreen () {
      if (this.isFullscreen) {
        this.exitFullscreen()
      } else {
        this.requestFullscreen()
      }
    },
    onFullscreenState () {
      const el = document

			if(el.fullscreenElement ||
				el.mozFullScreenElement || 
				el.msFullscreenElement ||
				el.webkitFullscreenElement
			) {
        this.isFullscreen = true

        document.addEventListener('keyup', this.onArrowsKeyUp)
			} else {
        this.isFullscreen = false

        document.removeEventListener('keyup', this.onArrowsKeyUp)
			}
    },
    onStart () {
      this.start = true

      this.togglePlay()

      this.sendEventGA('Slideshow', 'Play')
    },
    init () {
      if (this.ready) {
        this.slideshow = this.$refs.slideshow
        this.addActiveSlide(this.indexSlide)

        this.slideshow.addEventListener('fullscreenchange', this.onFullscreenState)

        if (this.isPlaying) {
          this.runTimeout()
        }
      }
    }
  },
  mounted() {
    this.init()
  },
  destroyed () {
    this.pauseTimeout()

    this.slideshow.removeEventListener('fullscreenchange', this.onFullscreenState)
  },
  watch: {
    ready () {
      this.init()
    }
  }
}
